<sbb-icon-sidebar-container [class]="getSidebarClassTag()">
  <sbb-icon-sidebar [(expanded)]="expanded">
    <a
      *ngIf="!disableBackend"
      sbbIconSidebarItem
      [label]="'app.netzgrafik-application.variants' | translate"
      [class]="getVariantsActivatedTag()"
      (click)="onVariantenClicked()"
    >
      <sbb-icon *ngIf="getVariantIsWritable()" svgIcon="document-standard-small"></sbb-icon>
      <sbb-icon
        *ngIf="!getVariantIsWritable()"
        svgIcon="folder-lock-small"
        style="color: #c60018"
      ></sbb-icon>
    </a>
    <a
      sbbIconSidebarItem
      [label]="'app.netzgrafik-application.filter' | translate"
      [class]="getFilterActivatedTag()"
      [style]="getFilterStyle()"
      (click)="onFilterClicked()"
    >
      <sbb-icon svgIcon="filter-small"></sbb-icon>
    </a>
    <a
      sbbIconSidebarItem
      [label]="'app.netzgrafik-application.edit' | translate"
      [class]="getEditActivatedTag()"
      [style]="getEditStyle()"
      (click)="onEditToolClicked()"
    >
      <sbb-icon svgIcon="pen-small"></sbb-icon>
    </a>
    <a
      sbbIconSidebarItem
      [label]="'app.netzgrafik-application.more-functions' | translate"
      [class]="getMoreFunctionActivatedTag()"
      (click)="onToolsClicked()"
    >
      <sbb-icon svgIcon="nine-squares-small"></sbb-icon>
    </a>
    <a
      sbbIconSidebarItem
      [label]="'app.netzgrafik-application.settings' | translate"
      [class]="getPropertiesActivatedTag()"
      (click)="onPropertiesClicked()"
    >
      <sbb-icon svgIcon="controls-small"></sbb-icon>
    </a>
  </sbb-icon-sidebar>

  <sbb-icon-sidebar-content role="main">
    <sbb-filter-main-side-view></sbb-filter-main-side-view>
  </sbb-icon-sidebar-content>
</sbb-icon-sidebar-container>
